/* eslint-disable @next/next/next-script-for-ga */
import Head from 'next/head'

import { NextSeo } from 'next-seo'

import { mapToProductSchema } from '@/constants'
import { useNotification } from '@/containers'
import type { Category, Post, Product } from '@/types'

interface MobileAlternate {
  media: string
  href: string
}
type IMetaProps = {
  title: string
  description: string
  keywords?: string[]
  canonical?: string
  mobileAlternate?: MobileAlternate
  imageUrl?: string
  imageAlt?: string
  noIndex?: boolean
  noFollow?: boolean
  dataSchema?: Product | Post | Category
  typeSchema?: string
}

const Meta = ({
  title = '',
  description = '',
  keywords = [],
  canonical = '',
  mobileAlternate,
  imageUrl = '',
  imageAlt = '',
  noIndex = true,
  noFollow = true,
  dataSchema,
  typeSchema
}: IMetaProps) => {
  const { systemConfig } = useNotification()

  function removeAllQueryParams(url: string) {
    const parsedUrl = new URL(url)
    const baseUrl = parsedUrl.origin + parsedUrl.pathname

    return baseUrl
  }

  //   const currentRegion = getCookie('sale-region')
  let schemaObject = {}

  if (dataSchema && typeSchema == 'product') {
    schemaObject = mapToProductSchema(dataSchema)
  }

  return (
    <>
      <Head>
        <meta charSet='UTF-8' key='charset' />
        <meta name='viewport' content='width=device-width,initial-scale=1' key='viewport' />
        <meta name='theme-color' content='#FF4B32' />
        <link rel='icon' type='image/png' href='/favicon-96x96.png' sizes='96x96' />
        <link rel='icon' type='image/svg+xml' href='/favicon.svg' />
        <link rel='shortcut icon' href='/favicon.ico' />
        <link rel='apple-touch-icon' sizes='180x180' href='/apple-touch-icon.png' />
        <link rel='manifest' href='/site.webmanifest' />
        <script
          id='gtm'
          dangerouslySetInnerHTML={{
            __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GA_TRACKING_ID}')`
          }}
        />
        {dataSchema && typeSchema == 'product' && (
          <script
            type='application/ld+json'
            dangerouslySetInnerHTML={{
              __html: JSON.stringify(schemaObject, null, 2)
            }}
            key='product-jsonld'
          />
        )}
      </Head>
      <noscript>
        <iframe
          src={`https://www.googletagmanager.com/ns.html?id=${process.env.NEXT_PUBLIC_GA_TRACKING_ID}`}
          height='0'
          width='0'
          style={{ display: 'none', visibility: 'hidden' }}
        ></iframe>
      </noscript>
      <NextSeo
        title={title}
        description={description}
        canonical={removeAllQueryParams(canonical || process.env.NEXT_PUBLIC_URL_WEBSITE || '')}
        noindex={noIndex}
        nofollow={noFollow}
        mobileAlternate={{
          media: 'only screen and (max-width:991px))',
          href: mobileAlternate?.href || process.env.NEXT_PUBLIC_URL_WEBSITE_MOBILE || ''
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: keywords
              ? keywords.join(',')
              : `${systemConfig?.websiteWarehouseBrandName}, chuyên gia điện máy, điện tử, điện lạnh, điều hòa, tủ lạnh, máy giặt, đồ gia dụng, tivi, khuyến mại, giao hàng nhanh`
          }
        ]}
        openGraph={{
          title: title,
          description: description,
          url: canonical,
          images: [
            {
              url: imageUrl,
              width: 800,
              height: 600,
              alt: imageAlt
            }
          ],
          site_name: process.env.NEXT_PUBLIC_URL_WEBSITE
        }}
      />
    </>
  )
}

export { Meta }
